import {Component} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {MfaService} from "../../../_services/mfa.service";
import {AppModule} from "../../../app.module";
import {AlertService} from "../../../_services";
import {AlertType} from "../../../_models";
import {Router} from "@angular/router";

@Component({
    standalone: false,
  selector: "setup-mfa-email",
  templateUrl: 'setup-email.component.html',
  styleUrls: ['./setup-email.component.scss'],
})
export class SetupEmailMfaComponent {
  code: string = "";

  constructor(public mfaService: MfaService,
              public alertService: AlertService,
              public router: Router) {
  }

  init() {
    this.mfaService.initSetup('email').subscribe(
      r => this.alertService.success("Email sent"),
      e => this.router.navigate(['mfa']));
  }

  submit() {
    this.alertService.loading.next(true)
    this.mfaService.completeSetup('email', this.code).subscribe(s => {
      this.alertService.loading.next(false)
      this.router.navigate(['mfa'])
    }, e => {
      this.alertService.loading.next(false)
      this.alertService.alert(AlertType.Error, e.error.exceptionMessage)
    })
  }
}
